module.exports = __webpack_public_path__ + "static/media/add.adc4cf09.svg";